import { stdObject } from "../../../../data/types/stdObject";

export const dataFiltered = (e: string, searchArea: stdObject) => {
  return [searchArea.PERICO.value, searchArea.ESTD2ICO.value].every(
    (v) => v === "",
  )
    ? searchArea.results.items[e].list
    : searchArea.results.items[e].list.filter(
        (v: stdObject) =>
          searchArea.ESTD2ICO.value === "" ||
          (!Number(searchArea.ESTD2ICO.value) && !v.PAGCOY) ||
          (Number(searchArea.ESTD2ICO.value) && v.PAGCOY > 0),
      );
};
